import {
  InputType,
  EVENT_TEXTFIELD_INPUT,
  EVENT_TEXTFIELD_CLEAR,
  EVENT_TEXTFIELD_CLICK_PREPEND,
  EVENT_TEXTFIELD_FOCUS,
  EVENT_TEXTFIELD_CHANGE,
  EVENT_TEXTFIELD_BLUR,
} from "@slhuicore/textfield/src/textfield.constants";
import { IconDefaultType as IconType } from "@slhuiicon/icon";

const CLEARABLE_ICON_TYPE = IconType.ICO_CLOSE;

export {
  InputType,
  CLEARABLE_ICON_TYPE,
  EVENT_TEXTFIELD_INPUT,
  EVENT_TEXTFIELD_CLEAR,
  EVENT_TEXTFIELD_CLICK_PREPEND,
  EVENT_TEXTFIELD_FOCUS,
  EVENT_TEXTFIELD_CHANGE,
  EVENT_TEXTFIELD_BLUR,
};
